function getSvgCursor({ solution, useHex, paintMode }) {
  // if (paintMode === 'paint_unlock') {
  //   let path = `<path fill='white' d='M16.24,3.56L21.19,8.5C21.97,9.29 21.97,10.55 21.19,11.34L12,20.53C10.44,22.09 7.91,22.09 6.34,20.53L2.81,17C2.03,16.21 2.03,14.95 2.81,14.16L13.41,3.56C14.2,2.78 15.46,2.78 16.24,3.56M4.22,15.58L7.76,19.11C8.54,19.9 9.8,19.9 10.59,19.11L14.12,15.58L9.17,10.63L4.22,15.58Z' />`
  //   let svg = `<svg xmlns='http://www.w3.org/2000/svg' width='${24}' height='${24}'>${path}</svg>`
  //   let res = {
  //     '--rab-cursor': `url("data:image/svg+xml;utf8,${svg}"), auto`,
  //   }
  //   console.log(res)
  //   return res
  // }

  const dimensions = 32
  let rects = ''
  let x = 0

  const actions = solution.filter(i => i.strategy)
  // let actions = [{ strategy: 1 }]

  // console.log(actions)
  // const actions = [this.aActions[0]].filter(i => i.strategy)
  const H = 8
  const Y = dimensions - H
  actions.forEach((a, idx) => {
    const w = dimensions * a.strategy

    const startX = x
    const startY = Y
    const startPos = `M${startX},${startY}`

    const h = H
    const topLeftTopRight_l = `h${w}`
    const topRightBottomRight_l = `v${h}`
    const bottomRightBottomLeft_l = `h${-w}`
    const bottomLeftTopLeft_l = `v${-h}`
    const p = `${startPos} ${topLeftTopRight_l} ${topRightBottomRight_l} ${bottomRightBottomLeft_l} ${bottomLeftTopLeft_l}`

    let hex = useHex
      ? a.hex
      : getComputedStyle(document.body).getPropertyValue(`--clr-${a.css_class}`)

    // hex = '#3f3f3f'
    hex = hex.replace('#', '%23')
    const r = `<path d='${p} z' stroke-width='0' style='fill: ${hex}' />`
    rects = `${rects}${r}`

    x += w
  })
  // rects = `<g style='clip-path: url(#clipPath0)'>${rects}</g>`
  rects = `<g style='clip-path: url(%23clipPath0)'>${rects}</g>`
  const R = 4
  const topRight_c = `a${R},${R} 0 0 1 ${R},${R}`
  const bottomRight_c = `a${R},${R} 0 0 1 ${-R},${R}`
  const leftBottom_c = `a${R},${R} 0 0 1 ${-R},${-R}`
  const topLeft_c = `a${R},${R} 0 0 1 ${R},${-R}`

  const clipPath = `M${R},${Y} ${`h${dimensions - R * 2}`} ${topRight_c} v${
    H - R * 2
  } ${bottomRight_c} h${-dimensions + R * 2} ${leftBottom_c} v${-H + R * 2} ${topLeft_c}`
  const defs = `<defs><clipPath id='clipPath0'><path d='${clipPath}'/></clipPath></defs>`

  // bucket mdi-format-color-fill
  // const icon = `<path fill='white' style='transform:scale(1.125)' d='M19,11.5C19,11.5 17,13.67 17,15A2,2 0 0,0 19,17A2,2 0 0,0 21,15C21,13.67 19,11.5 19,11.5M5.21,10L10,5.21L14.79,10M16.56,8.94L7.62,0L6.21,1.41L8.59,3.79L3.44,8.94C2.85,9.5 2.85,10.47 3.44,11.06L8.94,16.56C9.23,16.85 9.62,17 10,17C10.38,17 10.77,16.85 11.06,16.56L16.56,11.06C17.15,10.47 17.15,9.5 16.56,8.94Z' />`
  // let svg = `<svg xmlns='http://www.w3.org/2000/svg' width='${dimensions}' height='${dimensions}'>${defs}${icon}${rects}</svg>`

  // brush mdi-brush
  const icon = `<path fill='white' style='transform:scale(1.125)' d='M20.71,4.63L19.37,3.29C19,2.9 18.35,2.9 17.96,3.29L9,12.25L11.75,15L20.71,6.04C21.1,5.65 21.1,5 20.71,4.63M7,14A3,3 0 0,0 4,17C4,18.31 2.84,19 2,19C2.92,20.22 4.5,21 6,21A4,4 0 0,0 10,17A3,3 0 0,0 7,14Z' />`
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' style='transform:scaleY(-1)'  width='${dimensions}' height='${dimensions}'>${defs}${icon}${rects}</svg>`

  const res = {
    '--rab-cursor': `url("data:image/svg+xml;utf8,${svg}"), auto`,
    // svg,
  }
  return res
}

function getRelativeSimilarity({ refNum, newNum }) {
  const absDiff = Math.abs(refNum - newNum)
  const relativeDiff = absDiff / (refNum || 1)
  if (relativeDiff > 1) {
    return 1
  }
  const relativeSimilarity = Math.abs(1 - relativeDiff)
  return relativeSimilarity
}

function getStrategiesFromCombos({ combos }) {
  const strategies = []
  combos.forEach(c =>
    c.solution.forEach(a => {
      if (c.hero.range) {
        strategies.push(a.strategy)
      }
    }),
  )
  return strategies
}

function getStrategiesSimple({ combos }) {
  const strategies = []
  combos.forEach(c => {
    if (c.hero.range) {
      let raiseStr = 0
      c.solution.forEach(a => {
        if (a.type === 'RAISE') {
          raiseStr += a.strategy
        } else {
          strategies.push(a.strategy)
        }
      })
      strategies.push(raiseStr)
    }
  })
  return strategies
}

function getStrategiesByKeyedCombos({ combos, groupedActions }) {
  const keyedCombos = []
  combos.forEach(c => {
    const comboActionStrs = {}
    c.solution.forEach(a => {
      comboActionStrs[a.code] = a.strategy
    })
    keyedCombos.push({ id: c.id, strategies: comboActionStrs })
  })
  const strategies = []
  keyedCombos.forEach(c => {
    const groupStrategies = groupedActions.map(actionGroup => {
      const res = (actionGroup.actions || [actionGroup]).reduce((a, actionGroupAction) => {
        const r = a + c.strategies[actionGroupAction.code]
        return r
      }, 0)
      return res
    })
    strategies.push(groupStrategies)
  })
  return strategies.flat()
}

function getScoreGroups() {
  return [
    {
      id: 'perfect',
      clr: 'var(--clr-primary)',
      icon: 'mdi-check-all',
      to: n => n <= 1,
      from: n => n >= 0.75,
    },
    {
      id: 'good',
      clr: 'var(--clr-primary)',
      icon: 'mdi-check',
      to: n => n < 0.75,
      from: n => n >= 0.6,
    },
    {
      id: 'inaccuracy',
      clr: 'var(--clr-yellow)',
      icon: 'mdi-information-outline',
      to: n => n < 0.6,
      from: n => n >= 0.4,
    },
    {
      id: 'mistake',
      clr: 'var(--clr-error)',
      icon: 'mdi-alert',
      to: n => n < 0.4,
      from: n => n >= 0,
    },
  ]
}
function getScoreGroup(num) {
  const opts = getScoreGroups()
  const fallback = {
    id: 'na',
    clr: 'var(--clr-grey-2)',
    icon: '',
  }
  const res = opts.find(i => i.to(num) && i.from(num)) || fallback
  return res
}

function getEqualSolution({ solution, total = 1 }) {
  const stra = total / solution.length
  const res = solution.map(a => ({
    ...a,
    strategy: stra,
  }))
  // console.log('getEqualSolution', res)
  return res
}

export {
  getScoreGroups,
  getScoreGroup,
  getRelativeSimilarity,
  getSvgCursor,
  getStrategiesFromCombos,
  getStrategiesSimple,
  getStrategiesByKeyedCombos,
  getEqualSolution,
}
